<template>
  <div class="fabulous" :class="{ is_invitation: isExInvitation }">
    <div class="fabulous-title">
      <span>{{ wCount(count.viewCount) }} professionals have visited</span>
    </div>
    <div class="img_wrap" style="margin-top: 0.12rem">
      <template v-for="(item, index) in visitOpt.items">
        <div class="vis_div" :key="index">
          <div class="flag-icon vis_img " :class="'flag-icon-' + item.countryCode"></div>
          <p>{{ wCount(item.viewCount) }}</p>
        </div>
        <!-- <img
          v-if="item.userInfo.avatarUrl"
          :src="item.userInfo.avatarUrl"
          v-load="'oPicXS'"
          alt
          class="avatarUrl"
          :key="index"
        /> -->
        <!-- <img
          v-if="item.userInfo&&item.userInfo.avatarUrl"
          :src="item.userInfo.avatar Url"
          alt
          class="avatarUrl"
          :key="index"
        />
        <span class="flag-icon avatarUrl" v-else-if="item.userInfo.flagStyle" :class="'flag-icon-'+item.userInfo.flagStyle" :key="index"></span>
        <span class="flag-icon avatarUrl" v-else-if="item.ipFlagStyle" :class="'flag-icon-'+item.ipFlagStyle" :key="index"></span> -->
      </template>
    </div>
    <div class="more-avatarUrl" v-if="!visitOpt.finished" style="text-align: center">
      <div class="more_wrap" @click="visitMore">
        <span class="more-btn">MORE</span>
        <i class="iconfont icon-right-fill icon"></i>
      </div>
    </div>
    <div class="u-heart-theme" style="margin-top: 0.7rem; margin-bottom: 0.32rem" :style="{ color: themeColor }">
      <div class="dot-box">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="icon iconfont icon-dianzan" v-if="!isLike" @click="likeClick"></div>
      <div class="like_img" v-else @click="likeClick">
        <img src="@assets/img/new/like_ty.png" />
      </div>
      <!-- <div  class="icon iconfont icon-dianzanxuanzhong" v-else  @click="likeClick" ></div> -->
    </div>
    <div class="dianzan">
      <span>{{ wCount(count.likeCount) }} professionals like(s)</span>
    </div>
    <div class="userName img_wrap">
      <div class="vis_div" :key="index" v-for="(item, index) in likeOpt.items">
        <div class="flag-icon vis_img " :class="'flag-icon-' + item.countryCode"></div>
        <p>{{ wCount(item.likeCount) }}</p>
      </div>
      <div class="more-avatarUrl" v-if="!likeOpt.finished">
        <div class="more_wrap" @click="likeMore">
          <span class="more-btn">MORE</span>
          <i class="iconfont icon-right-fill icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "index",
  props: {
    isExInvitation: {
      type: Boolean,
      default: false,
    },
    visitOpt: {
      type: Object,
      default: () => {
        return {
          finished: false,
          page: 1,
          size: 20,
          totalCount: 0,
          items: [],
        };
      },
    },
    likeOpt: {
      type: Object,
      default: () => {
        return {
          finished: false,
          page: 1,
          size: 30,
          totalCount: 0,
          items: [],
        };
      },
    },
    isLike: {
      type: Boolean,
      default: false,
    },
    targetType: {
      type: String,
      default: "",
    },
    targetId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      themeColor: "#0190fe",
      count: {
        likeCount: 0,
        viewCount: 0,
        userCount: 0,
      },
    };
  },
  computed: {
    getUserStr() {
      let str = "";
      // console.log(this.likeOpt);
      this.likeOpt.items.forEach((el) => {
        if (el.userInfo.nickName) {
          str += str ? "，" + el.userInfo.nickName : el.userInfo.nickName;
        } else if (el.userInfo.name) {
          str += str ? "，" + el.userInfo.name : el.userInfo.name;
        } else {
          str += str ? "，" + "游客" : "Tourist";
        }
      });
      return str;
    },
  },
  created() {
    console.log(this.visitOpt, "----");
  },
  methods: {
    ...mapActions({
      graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
    }),
    async init() {
      let query = `
        {
          ipActionCountQuery {
            sumIp(targetType: "${this.targetType}", targetId: "${this.targetId}") {
              userCount
              viewCount
              likeCount
            }
          }
        }
      `;
      let opt = {
        query: query,
        variables: {},
      };
      let data = await this.graphqlPost(opt);
      let res = JSON.parse(JSON.stringify(data.data.ipActionCountQuery.sumIp));
      if (res) {
        console.log(data, "data点赞组件");
        this.count = res; 
      }
    },
    //访问更多点击
    visitMore() {
      this.$emit("visitMore");
    },
    //点赞更多点击
    likeMore() {
      this.$emit("likeMore");
    },
    //点赞点击
    likeClick() {
      this.$emit("likeClick");
    },
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./scss/heart.scss";
@import "./scss/water.scss";
@import "@assets/scss/utils.scss";
.fabulous {
  background-color: #fff;
  margin-top: 0.2rem;
  margin-bottom: 0.98rem;
  padding: 0.4rem 0.3rem 0.45rem;
  &.is_invitation {
    padding: 0.4rem 0.25rem 0.45rem;
    border-radius: 0.3rem;
    .img_wrap {
      margin-left: -0.2rem;
      .vis_div {
        display: flex;
        align-items: center;
        padding: 0.02rem 0 0.02rem 0.02rem;
        height: 0.46rem;
        background: #f7f7f7;
        border-radius: 90px;
        margin-left: 0.2rem;
        margin-top: 0.2rem;
        .vis_img {
          width: 0.42rem;
          height: 0.42rem;
          border-radius: 50%;
        }
        p {
          font-size: 0.22rem;
          padding: 0 0.2rem 0 0.1rem;
          color: #595757;
        }
      }
    }
    .avatarUrl {
      margin-left: 0.2rem;
      width: 0.46rem;
      height: 0.46rem;
      margin-top: 0.2rem;
    }
    .userName {
      &.img_wrap {
        margin: 0.4rem 0 0;
      }
      .more-avatarUrl {
        margin-top: 0.36rem;
      }
    }
  }
  .fabulous-title {
    text-align: center;
    color: #595757;
  }
  .img_wrap {
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.25rem;
  }
  .vis_div {
    display: flex;
    align-items: center;
    padding: 0.02rem 0 0.02rem 0.02rem;
    height: 0.46rem;
    background: #f7f7f7;
    border-radius: 90px;
    margin-left: 0.25rem;
    margin-top: 0.2rem;
    .vis_img {
      width: 0.42rem;
      height: 0.42rem;
      border-radius: 50%;
    }
    p {
      font-size: 0.22rem;
      padding: 0 0.2rem 0 0.1rem;
      color: #595757;
    }
  }
  .more-avatarUrl {
    margin-top: 0.4rem;
    .more_wrap {
      display: inline-block;
    }
    .more-btn {
      color: #1890ff;
    }
    .icon {
      display: inline-block;
      transform: rotate(90deg);
      color: #1890ff;
      margin-left: 0.16rem;
    }
  }
  .dianzan {
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
    margin-top: 0.32rem;
    color: #0190fe;
  }
  .userName {
    margin: 0.4rem 0;
    .more-avatarUrl {
      text-align: center;
    }
  }
}
</style>
<style scoped lang="scss">
::after,
::before {
  box-sizing: border-box;
}
@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.u-heart-theme:after,
.u-heart-theme .dot-box,
.u-heart-theme .dot-box:after,
.u-heart-theme .dot-box i:after,
.like_img,
.like_img img,
.u-heart-theme .heart,
.u-heart-theme .heart:before,
.u-heart-theme .heart:after,
.u-heart-theme .icon:before {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.u-heart-theme {
  border-radius: 50%;
  height: 100px;
  width: 100px;
  position: relative;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.u-heart-theme:after {
  content: "";
  border-radius: 50%;
  height: 50%;
  width: 50%;
  background-color: currentColor;
  -webkit-box-shadow: 0px 0px 4px 0px rgba(8, 8, 8, 0.2);
  box-shadow: 0px 0px 4px 0px rgba(8, 8, 8, 0.2);
}

.u-heart-theme .dot-box {
  -webkit-animation: rotate360 2s forwards infinite linear;
  animation: rotate360 2s forwards infinite linear;
  width: 100%;
  height: 100%;
  position: absolute;
}

.u-heart-theme .dot-box:before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
  opacity: 0.2;
  top: 0;
  left: 0;
  border: 1px solid currentColor;
}

.u-heart-theme .dot-box:after {
  content: "";
  border-radius: 50%;
  height: 75%;
  width: 75%;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border: 1px solid #3dbfdf;
  border-color: currentColor;
  opacity: 0.4;
}

.u-heart-theme .dot-box i {
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  border: 1px solid #3dbfdf;
  border-color: currentColor;
  opacity: 0.2;
}

.u-heart-theme .dot-box i:after {
  content: "";
  z-index: 2;
  display: inline-block;
  background: currentColor;
  border-radius: 50%;
  height: 4px;
  width: 4px;
}

.u-heart-theme .dot-box i:nth-child(1) {
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}

.u-heart-theme .dot-box i:nth-child(2) {
  top: 66%;
  left: 0;
  -webkit-transform: translateX(-25%) translateY(-50%);
  transform: translateX(-25%) translateY(-50%);
}

.u-heart-theme .dot-box i:nth-child(3) {
  top: 66%;
  right: 0;
  -webkit-transform: translateX(25%) translateY(-50%);
  transform: translateX(25%) translateY(-50%);
}

.u-heart-theme .heart {
  z-index: 2;
  -webkit-animation-name: scale1;
  animation-name: scale1;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  border-radius: 50%;
  height: 30%;
  width: 30%;
}

.u-heart-theme .heart.good:before,
.u-heart-theme .heart.good:after {
  background-color: #c9c9c9;
}

.u-heart-theme .heart:before,
.u-heart-theme .heart:after {
  content: "";
  width: 12px;
  height: 18px;
  background-color: #fff;
  border-radius: 6px 6px 0 0;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
}

.u-heart-theme .heart:after {
  right: 13px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transform-origin: 100% 100%;
  transform-origin: 100% 100%;
}

.u-heart-theme .heart:before {
  left: 13px;
}

.u-heart-theme .icon {
  z-index: 2;
  -webkit-animation-name: scale1;
  animation-name: scale1;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 30px;
  color: #fff;
  display: inline-block;
  position: relative;
  transform: translateY(-0.02rem);
  // &.icon-dianzanxuanzhong:before {
  //   border-radius: 50%;
  //   box-shadow: 3px 0 10px #000e42;
  // }
}
.like_img img {
  z-index: 2;
  width: 30px;
  height: 30px;
  display: block;
  // transform: scaleY(-0.02rem);
  transform: translateY(0.02rem) translateX(0.01rem);
}
.u-heart-theme .icon:before {
  width: 30px;
  height: 35px;
  display: inline-block;
  z-index: 3;
}
</style>
